import columns from './columns'
import format from './format'
import transform from './transform'

const {
  types: {
    date: dateProperties,
    numerical: numericalProperties,
  },
} = columns

const merge = {
  makeMergeId(mergedItem, mergeMap) {
    return mergeMap.reduce((mergeId, propertyName, currentIndex) => {
      const isDateProperty = dateProperties.indexOf(propertyName) !== 1
      const itemValue = mergedItem[propertyName]
      const isLastPropertyInMergeMap = currentIndex + 1 === mergeMap.length
      const delimiter = isLastPropertyInMergeMap ? '' : '/'

      if (itemValue) {
        if (isDateProperty) {
          if (Array.isArray(itemValue) && itemValue.length) {
            mergeId += `${itemValue}${delimiter}`
          } else {
            mergeId += `${itemValue.replace(/\//g, '')}${delimiter}`
          }
        } else {
          mergeId += `${String(itemValue).replace(/\s/g, '')}${delimiter}`
        }
      }

      return mergeId
    }, '')
  },
  mergeItem(properties, item) {
    return (mergeObject, property) => {
      const isMergeProperty = properties.includes(property)

      if (isMergeProperty) {
        mergeObject[property] = `${format.titlecase(property)} Summary`
      } else {
        mergeObject[property] = item[property]
      }

      return mergeObject
    }
  },
  reduce(properties, mergeMap) {
    return (mergedItems, item) => {
      const mergedItem = Object.keys(item).reduce(merge.mergeItem(properties, item), {})
      const mergeId = merge.makeMergeId(mergedItem, mergeMap)

      if (mergedItems[mergeId]) {
        mergedItems[mergeId].push(mergedItem)
      } else {
        mergedItems[mergeId] = [mergedItem]
      }

      return mergedItems
    }
  },
  combine(items, reportColumnsByKey) {
    const { length } = items
    const getValue = (value) => (Array.isArray(value) ? [...value] : [value])
    const setValue = (propertyName, item, mergedItem) => {
      const mergeValue = getValue(item.normalized[propertyName])

      mergeValue.forEach((val) => {
        if (mergedItem[propertyName].indexOf(val) === -1) {
          mergedItem[propertyName].push(val)
        }
      })
    }

    const result = items.reduce((mergedItem, item) => {
      Object.keys(item).forEach((propertyName) => {
        if (propertyName !== 'normalized') {
          if (numericalProperties.indexOf(propertyName) !== -1) {
            if (!mergedItem[propertyName]) {
              mergedItem[propertyName] = 0
            }
            const value = item.normalized[propertyName]

            if (value !== 'n/a' && !Number.isNaN(value)) {
              mergedItem[propertyName] += value
            }
          } else if (!mergedItem[propertyName]) {
            mergedItem[propertyName] = []
            setValue(propertyName, item, mergedItem)
          } else {
            setValue(propertyName, item, mergedItem)
          }
        }
      })

      return mergedItem
    }, {})

    const averages = ['ctr', 'ecpm', 'fillRate', 'osi', 'potentialLostRevenuePercentage', 'rate', 'yieldEstimatedCPM']

    averages.forEach((property) => {
      if (result[property]) {
        result[property] /= length
      }
    })

    return transform.freeze(result, reportColumnsByKey)
  },

  set(items, properties, mergeMap, columnsByKey) {
    const hasData = properties?.length && items?.length

    if (!hasData) {
      return Promise.resolve(items)
    }

    const groupsToMerge = items.reduce(merge.reduce(properties, mergeMap), {})
    const mergeKeys = Object.keys(groupsToMerge)

    return Promise.all(mergeKeys.reduce((mergedItemsArray, mergeKey) => {
      const itemsInMergeGroup = groupsToMerge[mergeKey]
      const mergedRows = merge.combine(itemsInMergeGroup, columnsByKey)

      mergedItemsArray.push(mergedRows)

      return mergedItemsArray
    }, []))
  },
}

export default merge
